import { EMPTY_LIST } from '../../../constants/common'

export function filterActivityByLabel({ label }, search) {
  return label?.toLowerCase().includes(search.toLowerCase())
}

export function getEmailTableRowActivityItems(activities = EMPTY_LIST) {
  return activities.map(activity => {
    return {
      key: activity.id,
      label: activity.title,
    }
  })
}
